/**
 * Returns a list with stopwords for the French passive voice assessment.
 * @returns {Array} The list with stopwords.
 */
export default function() {
	return [
		"et",
		"ou",
		"car",
		"or",
		"puisque",
		"puisqu'il",
		"puisqu'ils",
		"puisqu'elle",
		"puisqu'elles",
		"puisqu'un",
		"puisqu'une",
		"puisqu'on",
		"quand",
		"lorsque",
		"lorsqu'il",
		"lorsqu'elle",
		"lorsqu'ils",
		"lorsqu'elles",
		"lorsqu'on",
		"lorsqu'un",
		"lorsqu'une",
		"quoique",
		"quoiqu'il",
		"quoiqu'ils",
		"quoiqu'elle",
		"quoiqu'elles",
		"quoiqu'on",
		"quoiqu'un",
		"quoiqu'une",
		"qu'elle",
		"qu'il",
		"qu'ils",
		"qu'elles",
		"qu'on",
		"qu'un",
		"qu'une",
		"si",
		"s'ils",
		"s'il",
		"quand bien même",
		"pourquoi",
		"après",
		"avant",
		"afin de",
		"compte tenu de",
		"pour ne pas dire",
		"sinon",
		"une fois",
		"sitôt",
		"dont",
		"lequel",
		"laquelle",
		"lesquels",
		"lesquelles",
		"auquel",
		"auxquels",
		"auxquelles",
		"duquel",
		"desquels",
		"desquelles",
		"qui",
		"où",
		"d'où",
		":",
		"allé",
		"entré",
		"resté",
		"retombé",
		"apparu",
		"réapparu",
		"devenu",
		"redevenu",
		"intervenu",
		"provenu",
		"resurvenu",
		"survenu",
		"allés",
		"entrés",
		"restés",
		"retombés",
		"apparus",
		"réapparus",
		"devenus",
		"redevenus",
		"intervenus",
		"provenus",
		"resurvenus",
		"survenus",
		"allée",
		"entrée",
		"restée",
		"retombée",
		"apparue",
		"réapparue",
		"devenue",
		"redevenue",
		"intervenue",
		"provenue",
		"resurvenue",
		"survenue",
		"allées",
		"entrées",
		"restées",
		"retombées",
		"apparues",
		"réapparues",
		"devenues",
		"redevenues",
		"intervenues",
		"provenues",
		"resurvenues",
		"survenues",
	];
}
